import CircularProgress from '@mui/material/CircularProgress';
import { ReactElement } from 'react';

const LoadingSpinnerComponent = (): ReactElement => <CircularProgress size={50} color="inherit" />;

export default LoadingSpinnerComponent;
